export default __webpack_public_path__ + "static/media/copy.1ba1d625.svg";